import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class MagazineCategoryService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    createNewCategory(title, slug, parent) {
        let data

        if (parent >= 0) {
            data = {
                slug,
                title,
                parent: {
                    id: parent
                },
                root: false
            }
        } else {
            data = {
                slug,
                title,
                root: true
            }
        }

        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `post-categories`,
                data
            ).then(resolve).catch(reject)
        })
    }

    getCategoryTree() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `post-categories/trees`
            ).then(resolve).catch(reject)
        })
    }

    getCategoryDetail(id) {

        const detail = this.httpClient.get(
            `post-categories/${id}`
        )
        const thumbnail = this.httpClient.get(
            `post-categories/${id}/images`
        )
        const icon = this.httpClient.get(
            `post-categories/${id}/icons`
        )

        const requests = [
            detail,
            thumbnail,
            icon
        ]

        // axios.spread(

        return new Promise((resolve, reject) => {
            axios.all(requests)
                .then(axios.spread((detail, thumbnail, icon) => {
                        resolve({
                            detail, thumbnail, icon
                        })
                    })
                ).catch(reject)
        })
    }

    updateCategory(id, title, slug, parent) {
        let data

        if (parent >= 0) {
            data = {
                slug,
                title,
                parent: {
                    id: parent
                },
                root: false
            }
        } else {
            data = {
                slug,
                title,
                root: true
            }
        }

        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `post-categories/${id}`,
                data
            ).then(resolve).catch(reject)
        })
    }

    updateCategoryThumbnail(id, file) {
        let data = new FormData()
        data.append('file', file)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(
                `post-categories/${id}/images`,
                {},
                data
            ).then(resolve).catch(reject)
        })
    }

    updateCategoryIcon(id, file) {
        let data = new FormData()
        data.append('file', file)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(
                `post-categories/${id}/icons`,
                {},
                data
            ).then(resolve).catch(reject)
        })
    }

    getCategoryThumbnail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/post-categories/${id}/images`
            ).then(resolve).catch(reject)
        })
    }

    getCategoryIcon(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/post-categories/${id}/icons`
            ).then(resolve).catch(reject)
        })
    }
}